import React, { useEffect, useState,useRef } from "react";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import { getSearchEventMember,getEventMemberData } from "./../../api/event";
import EventStore from "./../../stores/eventStore";
import {
  getSmartCardData,
} from "./../../api/smartcard";
import AppStore from "./../../stores/appStore";

const FormSmartCard = ({status, eventId,data}) => {
const { alertShow, setAlertShow, setAlertMsg, setAlertType } = AppStore();
const { setMembers } = EventStore();
const intervalRef = useRef(null);
let currentCard = "";
const [checkedCard, setCheckedCard] = useState(false);


const handleChange = async (event) => {
  setCheckedCard(event.target.checked);
    if(event.target.checked == true){
         intervalRef.current = setInterval(async () => {
            let res =  await  getSmartCardData();
            if(res.data.cid != currentCard){
                let  v  = { cardId: res.data.cid}
                let data = await getSearchEventMember(eventId, v);

               // console.log(data.data.data);
                if(data.data.data == ''){
                    setAlertType("error");
                    let sw_error = res.data.cid+" : ไม่พบข้อมูล";
                    setAlertMsg(sw_error);
                    setAlertShow(true);
                }else{
                  setMembers(data.data.data);
                }
                currentCard = res.data.cid;
                //console.log(res.data);
            }
           //หากไม่พบการเสียบ
           if(Object.keys(res.data).length == 0 ){
              getEventMemberData(setMembers, eventId);
           }
            
         }, 2000);
    }else{
       console.log('clear...');
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
       getEventMemberData(setMembers, eventId);
      
       
    }
    
  };

  useEffect(() => {
    if (data !== null) {
    }
  }, [data]);

  return (
    <>
      <Button
          variant="text"
            sx={{
            height: "35px", 

          }}
          >
          Smart Card
          <Switch
            
              defaultChecked={checkedCard}
              onChange={handleChange} 
                
            />
       </Button>
    </>
  );
};

export default FormSmartCard;
